export default "__VITE_ASSET__BCk3ogjR__"